import { createRoot } from 'react-dom/client';

import { App } from './App';
import '../shared/utils/i18n';

const selector = '.search-results-container';

const container = document.querySelector(selector);

document.addEventListener('DOMContentLoaded', () => {
  if (container) {
    const root = createRoot(container);

    root.render(<App />);
  }
});
